









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ZoomButtonComponent extends Vue {

    @Prop({ default: 'plus' })
    public zoomMode!: 'plus' | 'minus' | 'reset';

    get zoomIconValue(): string {
        if (this.zoomMode === 'reset') {
            return 'mdi-magnify-minus-cursor';
        } else {
            return `mdi-magnify-${this.zoomMode}-outline`;
        }
    }

};
